import { render, staticRenderFns } from "./ModuleTabs.vue?vue&type=template&id=66003764&scoped=true"
import script from "./ModuleTabs.vue?vue&type=script&lang=js"
export * from "./ModuleTabs.vue?vue&type=script&lang=js"
import style0 from "./ModuleTabs.vue?vue&type=style&index=0&id=66003764&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66003764",
  null
  
)

export default component.exports